<script lang="ts" setup>
import ThemeProvider from '@/design/widgets/theme-provider/index.vue';
import Account from '@/features/account/index.vue';
import SoundBtn from '@/features/landing/sound-btn/index.vue';
import { getFeUrl } from '@/utils/url';
import FloatFeatures from '@rendora/common/features/float-features/index.vue';
import MobileBottomUserPop from '~/design/widgets/mobile-bottom-user-pop/index.vue';
import TemplateModal from '~/features/template/components/modal.vue';

const key = 'x-muted';
// x-muted 1 unmuted 0 muted
const muted = ref(+getCookie(key) === 1 ? false : true);
const mobileUserRef = ref<{ open: () => void } | null>(null);
const { createMobileUserPopOwner, registerMobileUserPop } = useMobileUserPop();
const mobileUserPopOwnerId = createMobileUserPopOwner();

/** SSR 时为 true，用于 TemplateModal 占位避免 hydration mismatch */
const isSsrPlaceholder = !import.meta.client;

provide('isMuted', muted);

const toggleMuted = () => {
  muted.value = !muted.value;
  setCookie(key, muted.value ? 0 : 1);
};

useHead({
  meta: [
    {
      property: 'og:image',
      content: getFeUrl('/youyan-platform/png/homepage.png'),
    },
  ],
});

watch(
  mobileUserRef,
  value => {
    registerMobileUserPop(mobileUserPopOwnerId, value ? () => value.open() : null);
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  registerMobileUserPop(mobileUserPopOwnerId, null);
});
</script>

<template>
  <div class="layout-landing-root">
    <ThemeProvider>
      <article class="layout-landing">
        <div class="layout-landing__slot">
          <slot />
        </div>
      </article>
    </ThemeProvider>

    <sound-btn class="layout-landing__sound-btn" :muted="muted" @click="toggleMuted" />

    <div class="layout-landing-root__modal-wrap">
      <TemplateModal :ssr-placeholder="isSsrPlaceholder" />
    </div>

    <MobileBottomUserPop ref="mobileUserRef" />
    <Account class="layout-landing__account"></Account>
    <FloatFeatures class="layout-landing__float-features"></FloatFeatures>
  </div>
</template>

<style lang="scss" src="./styles/layout.mobile.scss" />
<style lang="scss" src="./styles/layout.pc.scss" />
